/**
 * 转场特效 - spiralz (svg实现方法)
 * 2018-10-29
 */
(function (root, factory) {
  if (typeof module === 'object' && typeof module.exports === 'object') {
    module.exports = factory(this);
  } else {
      factory(root);
  }
})(this, function (root) {
  function con(scene, option) {
    this.code = option.code || 'Spiralz';
    this.maskEle = $('<div></div>').attr({id: 'maskEle_' + scene.id});
    this.control = []; // 扇形的控制对象
    this.controls = []; // 弧形的控制对象
    this.r = []; // 扇形的直径
    this.rs = []; // 弧形的直径
  }

  var methods = {
    init: function (force) {
      this.duration = 1.6;
      this.startAt = 0.7;

      return this.supr(this.startAt, force).then(function () {
      });
    },
    initDom: function() {
      if(!this.maskEle) return;
      
      var editor = this.scene.editor,
          w = editor.clientWidth,
          h = editor.clientHeight;

      this.maskEle.hide();
      editor.player.maskEle.append(this.maskEle)

      var svgMask = SVG('maskEle_' + this.scene.id).size(w, h);

      this.r = [];
      this.control = [];
      // 颜色的定义变量
      if (this.code === 'Spiralz') {
        var r = 236, g = 239, b = 241;
      }else {
        var r = 0, g = 199, b = 268;
      }
      for (var i = 0; i < 8; i++) {
        this.r[i] = h/7.85 * (i+1);
        if (this.code === 'Spiralz') {
          r-=21
          g-=20;
          b-=20;
        }else {
          g-=13;
          b-=13;
        }
        // 八个扇形
        this.control[i] = svgMask.circle().attr({
          cx: w / 2,
          cy: h / 2,
          r: this.r[i] / 2
        }).style({
          stroke: 'rgb('+r+', '+g+', '+b+')',
          'stroke-dashoffset': this.r[i]* Math.PI,
          'stroke-dasharray': this.r[i]* Math.PI,
          'stroke-width': this.r[i],
          'transform-origin': '50% 50% 0px',
          'fill': 'none'
        })
      }
      this.controls = [];
      this.rs = [];
      r = g = b = 250;
      for (var i = 0; i < 6; i++) {
        if (this.code === 'Spiralz') {
          r = g = b = r - i*i -2*i
        }else {
          i==1 && (r = 0, g = 186, b = 255);
          i==2 && (r = 238, g = 238, b = 238);
          i==3 && (r = 224, g = 224, b = 224);
          i==4 && (r = 0, g = 93, b = 128);
          i==5 && (r = 158, g = 158, b = 158);
        }
        this.rs[i] = w/6.15 * (i+1);
        // 六条弧线
        this.controls[i] = svgMask.circle().attr({
          cx: w / 2,
          cy: h / 2,
          r: this.rs[i] / 2
        }).style({
          stroke: 'rgb('+r+', '+g+', '+b+')',
          'stroke-dashoffset': this.rs[i]* Math.PI,
          'stroke-dasharray': this.rs[i]* Math.PI,
          'stroke-width': 1,
          'transform-origin': '0 0 0',
          'fill': 'none'
        })
      }
    },
    show: function(frame) {
      if(!this.isInit) return;
      this.supr(frame);

      var scene = this.scene,
          editor = scene.editor,
          sEle = scene.element.player; // player层的当前 scene

      var offFrame = frame - this.exit.start;

      // 播放层显示，对应scene显示
      editor.player.ele.show();
      sEle.show();

      // 衔接上一个场景页的动画(e.g.前0.5s的动画)
      if (frame <= this.entrance.end) {
        this.showFirst(frame)
      }

      // 本场景页的转场动画(e.g.后0.5s的动画)
      if (this.nexts && frame >= this.exit.start) {
        this.maskEle.show()
        var calcFrame = 0, calcTotal = 0;
        // 每个扇形的总时长一样
        calcTotal = this.frameRate * (this.startAt - 0.42);
        for (var i = 0; i < 8; i++) {
          // 每个扇形相较于前一个延后0.05秒出场
          calcFrame = offFrame - this.frameRate*0.06*i < 0 ? 0 : offFrame - this.frameRate*0.06*i;
          // 扇形旋转的效果
          if(calcFrame > calcTotal) calcFrame = calcTotal;
          this.control[i].style({
            'stroke-dashoffset': this.easeOutSine(calcFrame, this.r[i]* Math.PI, this.r[i]* Math.PI, calcTotal)
          })
        }
        calcTotal = this.frameRate * (this.startAt - 0.36);
        for (var i = 0; i < 6; i++) {
          calcFrame = offFrame - this.frameRate*0.06*i < 0 ? 0 : offFrame - this.frameRate*0.06*i;
          if(calcFrame > calcTotal) calcFrame = calcTotal;
          // 弧线的旋转效果
          this.controls[i].style({
            opacity: this.linear(calcFrame, 1, -1, calcTotal),
            'stroke-dashoffset': this.easeOutSine(calcFrame, -this.rs[i]* Math.PI, this.rs[i]* Math.PI*0.92, calcTotal),
          }).rotate(this.linear(calcFrame, 0, -200, calcTotal))
        }
      }

      // 动画外的时间
      if (frame > this.entrance.end && frame < this.exit.start) {
        this.showMiddle()
      }
    },
    easeOutSine: function(t, b, c, d) {
      return c * Math.sin(t/d * (Math.PI/2)) + b;
    },
    showNext: function(frame) {
      this.maskEle.show()

      // 具体解释参考上面
      var calcFrame = 0, calcTotal = 0, val;
      calcTotal = this.frameRate * (this.duration - this.startAt - 0.42);
      for (var i = 0; i < 8; i++) {
        calcFrame = frame - this.frameRate*0.06*(7-i) < 0 ? 0 : frame - this.frameRate*0.06*(7-i);
        if(calcFrame > calcTotal) calcFrame = calcTotal;
        val = this.easeOutSine(calcFrame, 0, this.r[i]* Math.PI, calcTotal);
        // 防止晃动
        this.r[i]* Math.PI - val < 4 && (val = this.r[i]* Math.PI);
        this.control[i].style({
          'stroke-dashoffset': val,
        })
      }
    },
    clearMask: function() {
      this.maskEle.remove();
      this.maskEle = $('<div></div>').attr({id: 'maskEle_' + this.scene.id});
      this.control = [];
      this.controls = [];
      this.r = [];
      this.rs = [];
      this.isInit = false;
    }
  }

  var statics = {}

  if (root.AnimEditor) {
    root.AnimEditor.extendScenesEffect('spiralz', con, methods, statics);
    return;
  }

  return function (AnimEditor) {
    AnimEditor.extendScenesEffect('spiralz', con, methods, statics);
  }
});



//////////////////
// WEBPACK FOOTER
// ./static/animengine/js/scene-effects/se-spiralz-svg.js
// module id = Ha4e
// module chunks = 16